import axios from "axios";
import {
  ScheduleCancelQuoteRequest,
  ScheduleCancelQuoteResponse,
} from "redmond";
import { config } from "../../config";
import { getActivitiesCancelQuoteSchedulePath } from "../paths";

export const getActivitiesCancelQuoteSchedule = async (
  req: ScheduleCancelQuoteRequest
): Promise<ScheduleCancelQuoteResponse> => {
  const res = await axios.post(getActivitiesCancelQuoteSchedulePath, req, {
    baseURL: config.baseURL,
  });

  return res.data;
};
